"use client";
import type { ReactElement } from "react";
import { motion } from "framer-motion";
import { getFontFamily } from "@/theme/typography";
import { AXIS_HEIGHT, TODAY_COLOR, TODAY_STROKE_DASH, } from "./gantt-constants";
const TODAY_MARKER_ANIMATION_DURATION = 3;
export interface GanttTodayMarkerProps {
    ganttIdPrefix: string;
    todayX: number;
    chartHeight: number;
    isEntranceComplete: boolean;
}
export function GanttTodayMarker({ ganttIdPrefix, todayX, chartHeight, isEntranceComplete, }: GanttTodayMarkerProps): ReactElement {
    const todayIdentity = `x-${todayX}`;
    return (
      <g data-el="Cmarkdowngantt/TodayMarker/Status">
      <line x1={todayX} y1={AXIS_HEIGHT} x2={todayX} y2={chartHeight} stroke={TODAY_COLOR} strokeWidth={1.2} strokeDasharray={TODAY_STROKE_DASH} opacity={0.6}/>
      <motion.line x1={todayX} y1={AXIS_HEIGHT} x2={todayX} y2={chartHeight} stroke={TODAY_COLOR} strokeWidth={2} opacity={0.45} filter={`url(#${ganttIdPrefix}-todayGlow)`} animate={isEntranceComplete
            ? { opacity: [0.4, 0.7, 0.4] }
            : { opacity: 0 }} transition={{
            duration: TODAY_MARKER_ANIMATION_DURATION,
            ease: "easeInOut",
            repeat: Number.POSITIVE_INFINITY,
        }}/>
      <text x={todayX + 6} y={12} fill={TODAY_COLOR} fontFamily={getFontFamily()} fontSize="10" fontWeight="700">
        Today
      </text>
      </g>
    );
}
